import React from 'react';

interface SupportEmailLinkProps {
  className?: string;
  style?: React.CSSProperties;
}

const SupportEmailLink: React.FC<SupportEmailLinkProps> = ({ className, style }) => {
  const defaultStyle: React.CSSProperties = {
    color: '#4A9EFF',
    textDecoration: 'underline',
    cursor: 'pointer',
    ...style
  };

  return (
    <a 
      href="mailto:support@oneplay.in" 
      className={className}
      style={defaultStyle}
      onClick={(e) => e.stopPropagation()}
    >
      support@oneplay.in
    </a>
  );
};

export default SupportEmailLink; 